define([
    'jquery'
], function($) {
    'use strict';

    var init = function() {
        $('a[rel*=external]').on('click', function(event) {
            event.preventDefault();
            event.stopPropagation();

            var $button = $(this),
                href = $button.attr('href');

            setTimeout(function() {
                // TODO: add Google Analytics tracking

                window.open(href);
            }, 200);
        });
    };

    return init;
});
